import React, { memo } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import pageStyles from "./../../pages/pageStyles";

const SectionReadForbidden = () => {
  const classes = pageStyles();

  return (
    <Paper
      className={classes.sectionWrapper}
      style={{
        margin: "20px auto",
      }}
    >
      <Box className={classes.sectionContentWrapper}>
        <Grid container className="text-center">
          <Typography color="textSecondary">
            No Permission to read this section
          </Typography>
        </Grid>
      </Box>
    </Paper>
  );
};

export default memo(SectionReadForbidden);
